SlideView  = require("views/slide")
YouTubeAPI = require("lib/youtube-api")
device     = require("lib/device")
App = require('app')

class YoutubeVideoEmbedView extends SlideView
  template: require("./template")

  events:
    "iostap": "playVideo"
    "click .btn-done": "submit"
    
  needCaptions: ->
    @options.data.videoId?.indexOf('cc_load_policy') > -1

  serialize: ->
    data = super
    data.submitUp = @needCaptions()
    data.continueBtnText = i18n("video.skip-video")
    data.skipButton = if data?.showSkipButton? then data.showSkipButton else false
    data.videoId = @options.data.videoId?.split('?')[0]
    data

  render: ->
    super

    @player = null
    @waitForAPI()

  beforeShow:  ->
    @trigger("ui", lightbox: true, flexibleHeight: true)
    @setState("loading", "video")
    
    if device.platform != "browser"
      Application.publish("event:rotation-unlock") {}
    
    if @options.data.autoplay
      @playVideo()

  show: ->
    title = document.getElementById("lesson-header-title-content")
    title?.setAttribute("tabindex", "0")
    title?.focus({ preventScroll: true })

  beforeHide: ->
    window.clearTimeout @waitForAPITimeout
    window.clearTimeout @checkForPlayerTimeout

    @player?.stopVideo?()

    if device.platform != "browser"
      Application.publish("event:rotation-lock") {}

    @trigger("ui", lightbox: false, flexibleHeight: false)

  waitForAPI: ->
    window.clearTimeout @waitForAPITimeout
    do repeat = =>
      if window.YT?.Player?
        @createPlayer()
      else
        @waitForAPITimeout = window.setTimeout(repeat, 100)

  playVideo: ->
    window.clearTimeout @checkForPlayerTimeout
    do repeat = =>
      if @player?.playVideo?
        @setState("loading", "video")
        @player.playVideo()
      else
        @checkForPlayerTimeout = window.setTimeout(repeat, 100)

  createPlayer: ->
    try
      el = @findOne(".yt-player")
      # some users include query parameters in video ID, e.g. cc_lang_pref
      [videoId, queryString] = @options.data.videoId.split('?')
      videoOptions = {}
      if queryString
        queryString.split('&').forEach((param) ->
          [key, value] = param.split('=')
          videoOptions[key] = value
        )
      videoOptions = Object.assign(videoOptions, {
        autoplay: 0
        controls: device.platform == 'Android'
        modestbranding: 0
        showinfo: 0
        rel: 0
        start: parseInt(@options.data.startTime, 10) or 0
        end: parseInt(@options.data.endTime, 10) or undefined
      })
      @player = new YT.Player el,
        videoId: videoId
        playerVars: videoOptions
        events:
          onReady: =>
            # fix issue with youtube not playing in SCORM because of referrer policy
            if (App.platform == 'scorm')
              $('.yt-player')?.first()?.attr('referrerpolicy','no-referrer')
            @setState("paused", "video")
          onStateChange: (e) =>
            switch e.data
              when YT.PlayerState.PLAYING then @setState("playing", "video")
              when YT.PlayerState.ENDED   then @onVideoEnded()
          onError: (e) =>
            console.error('youtube createPlayer error = ', e)
    catch err
      console.error('youtube createPlayer error = ', err)


  onRefresh: ->
    @beforeShow(true)

  onVideoEnded: () ->
    autoProgress = if @options.data?.autoProgress? then @options.data.autoProgress else true

    if autoProgress
      @submit()
    else
      @setState("touched")

  submit: (e) ->
    e?.stopImmediatePropagation()
    super

module.exports = YoutubeVideoEmbedView
